/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { ProjectResponse } from '@cp/customer-database-sdk'
import { z } from 'zod'

export class EngineHelpers {
  static getEngineName = (engine: string | undefined) => {
    return engine && renderEngine(engine)
  }
}

// Engines enum.
export const Engines = ProjectResponse.shape.engine.Enum
export type Engines = z.infer<typeof ProjectResponse.shape.engine>

const ENGINES_TO_NAME: Record<Engines, string> = {
  [Engines.GODOT]: 'Godot',
  [Engines.UNITY]: 'Unity',
  [Engines.UNREAL]: 'Unreal',
  [Engines.CUSTOM]: 'Custom',
  [Engines.UNKNOWN]: 'Unknown'
}

function renderEngine(engine: string) {
  return ENGINES_TO_NAME[engine as Engines] || 'Unidentified engine'
}
